import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Typography } from 'common/typography'

const PokedexTabStyled = styled.div`
  padding: 16px;
  p {
    font-family: var(--primaryFont);
  }
  img {
    height: 25px;
    margin-bottom: 16px;
  }
`

function PokedexTab({ src, title }) {
  return (
    <PokedexTabStyled>
      <img src={src} alt={`${title}-icon`} />
      <Typography fontWeight={500} fontSize={16} align="center" transform="capitalize">
        {title}
      </Typography>
    </PokedexTabStyled>
  )
}

PokedexTab.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default PokedexTab
